import { fetchCurrentIdToken } from "./util/login";

const apiConfig = {
  'customAuthStorage': {
      'domain': process.env.REACT_APP_CUSTOM_AUTH_STORAGE_DOMAIN,
      'path': '/',
      'secure': (process.env.NODE_ENV === 'production' || process.env.REACT_APP_CUSTOM_AUTH_STORAGE_SECURE === "true"),
      'sameSite': process.env.NODE_ENV === 'production' ? 'none' : 'lax'
  },
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
      userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN,
          scopes: ['openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [process.env.REACT_APP_SIGNIN],
          redirectSignOut: [process.env.REACT_APP_SIGNOUT],
          responseType: 'code'
        },
        
        username: 'true',
        email: 'false',
        phone: 'false',
      }
    }
  },
  API: {
    REST: {
      default: {
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
        service: "execute-api"
      }
    }
  },
  Analytics: {
    disabled: true,
  }
};

export const libraryOptions = {
  API: {
    REST: {
      headers: async () => {
        const token = await fetchCurrentIdToken();
        return {
          Authorization: token
        };
      }
    },
  },
};



export default apiConfig;
